import { ApplicationUser } from 'types/company/applicationUser';
import { fetcher } from 'utils/axios';

export const getFunnerUserStatus = async (phoneNumber: string) => {
  try {
    const data = await fetcher(
      'get',
      [
        '/api/services/GetFunnerUserStatus',
        {
          data: {
            phoneNumber,
          },
        },
      ],
      'history',
      true,
    );

    if (data)
      return data as {
        result: boolean;
        isOTPverified?: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in getFunnerUserStatus:', error);
    return null;
  }
};
export const sendOTPByPhone = async (phoneNumber: string) => {
  try {
    const data = await fetcher('get', `/api/auth/resendOTPByPhone/${phoneNumber}`, 'history', true);

    if (data)
      return data as {
        data: any;
      };
    else return null;
  } catch (error) {
    console.warn('Error in sendOTPByPhone:', error);
    return null;
  }
};
export const fetchVerifyOTP = async (PhoneNumber: string, OTP: string) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/auth/VerifyOTPByPhoneNumber',
        {
          data: {
            PhoneNumber,
            OTP,
          },
        },
      ],
      'history',
      true,
    );
    if (data)
      return data as {
        success: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in fetchVerifyOTP:', error);
    return null;
  }
};
export const addFunnerUserCompany = async (phone: string, otp: string) => {
  try {
    const data = await fetcher(
      'get',
      [
        '/api/services/addFunnerUserCompaniesList',
        {
          data: {
            phone,
            otp,
          },
        },
      ],
      'history',
    );
    if (data) return Boolean(data) as boolean;
    else return null;
  } catch (error) {
    console.warn('Error in addFunnerUserCompany:', error);
    return null;
  }
};
export const addCompanyFunnerUser = async (params: {
  Email: string;
  Password: string;
  PhoneNumber: string;
  FirstName: string;
  LastName: string;
}) => {
  try {
    const data = await fetcher('post', ['/api/auth/addCompanyFunnerUser', { data: params }], 'history');
    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in addCompanyFunnerUser:', error);
    return null;
  }
};
export const saveFunnerUserDetails = async (params: ApplicationUser) => {
  try {
    const data = await fetcher('post', ['/api/services/saveFunnerUserDetails', { data: params }], 'history');
    if (data) return data;
    else return null;
  } catch (error) {
    console.warn('Error in saveFunnerUserDetails:', error);
    return null;
  }
};
export const adminUpdateUserpic = async (formData: FormData) => {
  try {
    const data = await fetcher('post', ['/api/auth/adminUpdateUserpic', { data: formData }], 'history');
    if (data)
      return data as {
        result: boolean;
        image: string;
      };
    else return null;
  } catch (error) {
    console.warn('Error in adminUpdateUserpic:', error);
    return null;
  }
};
